import { EventSchema } from '../../interfaces/EventInterfaces';
import { EVENT_NAME as EN } from '../../constants/EventName';
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey';
import { CommonEventProperties } from '../../utils/CommonParams';

export const ProductRemovedFromCartEventSchema: EventSchema = {
    eventName: EN.PRODUCT_REMOVED_FROM_CART,
    params: {
        ...CommonEventProperties,
        BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
        EVENT_CATEGORY: EPK.EVENT_CATEGORY,
        FULFILMENT_CHANNEL: EPK.FULFILMENT_CHANNEL,
        CHECKOUT_FLOW: EPK.CHECKOUT_FLOW,
        PRODUCTS : EPK.PRODUCTS,
    }
}